export default __webpack_public_path__ + "static/media/add-icon.8937cc99.jpg";